import { Component, Inject, inject, model} from '@angular/core';

import {
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { HelperService } from '../../services/helper.service';
import { MaterialModule } from 'src/app/material.module';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrl: './pdf-viewer.component.scss',
  standalone: true,
  imports: [MaterialModule, NgxExtendedPdfViewerModule],
})
export class PdfViewerComponent {
  readonly dialogRef = inject(MatDialogRef<PdfViewerComponent>);
  readonly data = inject<any>(MAT_DIALOG_DATA);
  pdfView:any = null;
  fileName:any;
  isDownloadable:boolean=true;
  title:string = 'PDF Viewer';

  constructor(private helperService: HelperService) {
    this.pdfView = this.data.pdfView;
    this.fileName = this.data.fileName;
    this.isDownloadable = this.data.download;
    this.title = this.data.title || 'PDF Viewer';
    this.dialogRef.afterClosed().subscribe(()=>{
      this.pdfView=null;
    })
  }

  downloadPdf() {
    const data = {
      response: this.pdfView,
      fileName: this.fileName
    };
    
    this.helperService.downloadFile(data);
  }
  
  onNoClick(): void {
    this.dialogRef.close();
  }
}